import version from "./executors/version";

export const VERSION = version;
